/*** IMPORTS FROM imports-loader ***/
var global = window;

import { auto } from "../enums.js";
export default function getBasePlacement(placement) {
  return placement.split('-')[0];
}
